import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class DropboxService {

	headerStatus = '';

	constructor(
		private http: HttpClient
	) { }

	getAuthUrl(username: string, procoreUserId: number) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/dropbox/auth-url`;

		return this.http.get(requestUrl, { headers, params, responseType: 'text' });
	}

	createUserAuth(code: string, state: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('code', code);
		params = params.set('state', state);

		const requestUrl = `${environment.serviceUrl}/dropbox/user/auth`;

		return this.http.post(requestUrl, '', { headers, params, responseType: 'text' });
	}

	getUserAccount(username: string, procoreUserId: number) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/dropbox/user/account`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getRootFolders(username: string, procoreUserId: number) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/dropbox/folders`;

		return this.http.get<any>(requestUrl, { headers, params });
	}
}
